import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface OrganizacaoStorage {
  id?: string;
  client_id: string;
  nome?:  string;
  cnpj?: string;
  tipoOrganizacao?: string;
  telefone?: string;  
  logradouro?: {
    bairro?: string;
    cep?: string;
    codigoMunicipio?: string;
    id?: number;    
    localidade?: string;
    logradouro?: string;
    siglaUf?: string;
  }  
  numero?: string;
  complemento?: string;
  sigla?: string;
}

@Injectable()
export class OrgInfoService {

  public chaveOrganizacao: string   = "organizacaoSelecionada";
  public storage:          Storage  = sessionStorage;
  private storageSub                = new Subject<boolean>();

  constructor () { }

  watchStorage () : Observable<any> {
    return this.storageSub.asObservable();
  }

  /**
   * ADICIONA A ORGANIZACAO AO STORAGE LOCAL
   * @param organizacao 
   */
  adicionarOrganizacao (organizacao: string) {    
    this.storage.setItem (this.chaveOrganizacao, organizacao);
    this.storageSub.next(true);
  }

  /**
   * REMOVE A ORGANIZACAO LIMPANDO O STORAGE LOCAL
   */
  removerOrganizacao () {
    this.storage.removeItem (this.chaveOrganizacao);
    this.storageSub.next(true);
  } 

  /**
   * RETORNA OS DADOS DA ORGANIZACAO 
   * SALVOS LOCALMENTE ATRAVES DO STORAGE
   */
  getOrganizacao () : OrganizacaoStorage | null {
    try {
      let organizacao: string = this.storage.getItem (this.chaveOrganizacao);
      if (organizacao) {        
        return JSON.parse(this.storage.getItem (this.chaveOrganizacao));
      }
    } catch (error) {
      return null;
    }
  }

  /**
   * VERIFICA SE EXISTE UMA ORGANIZACAO
   * SELECIONADA E SALVA
   */
  verificaOrganizacao () {
    let organizacao: OrganizacaoStorage = this.getOrganizacao();    
    if (typeof organizacao === 'undefined') {
      return false;
    }
    if (organizacao.id === null || typeof organizacao.id === 'undefined') {
      return false;
    }
    return true;
  }

  getIdOrg () : string | null {
    if (this.getOrganizacao() !== null && typeof this.getOrganizacao().id != 'undefined' && this.getOrganizacao().id != null) {
      return this.getOrganizacao().id;
    }
    return null;
  }

  getClientId () : string | null {
    if (this.getOrganizacao() !== null) {
      return this.getOrganizacao().client_id;
    }
    return null;
  }

  getNomeOrganizacao () : string | null {
    if (this.getOrganizacao() !== null) {
      return this.getOrganizacao().nome;
    }
    return null;
  }

  getTipoOrganizacao () : string | null {
    if (this.getOrganizacao() !== null) {
      return this.getOrganizacao().tipoOrganizacao;
    }
    return null;
  }

  setOrganizacao (organizacao: OrganizacaoStorage) {
    if (organizacao === null || typeof organizacao === 'undefined') {
      return null;
    }

    let org : OrganizacaoStorage = {
      id: organizacao.id,
      client_id: organizacao.client_id,
      nome: organizacao.nome,
      tipoOrganizacao: organizacao.tipoOrganizacao,
      telefone: organizacao.telefone,
      logradouro: {
        bairro: organizacao.logradouro.bairro,
        cep: organizacao.logradouro.cep,
        codigoMunicipio: organizacao.logradouro.codigoMunicipio,
        id: organizacao.logradouro.id,
        localidade: organizacao.logradouro.localidade,
        logradouro: organizacao.logradouro.logradouro,
        siglaUf: organizacao.logradouro.siglaUf
      },
      numero: organizacao.numero,
      complemento: organizacao.complemento,
      sigla: organizacao.sigla
    }

    this.removerOrganizacao();
    this.adicionarOrganizacao(JSON.stringify(org));
  }

  getSigla(): string | null {
    if (this.getOrganizacao() !== null)
      return this.getOrganizacao().sigla;
    
    return null;
  }

  setSigla(sigla: string) {
    let org: OrganizacaoStorage = this.getOrganizacao();
    org.sigla = sigla;
    this.setOrganizacao(org);
  }  
  
}